import acordeon from "../lib/aria/acordeon";

const preguntasFrecuentes = () => acordeon('.preguntas_frecuentes__preguntas', false);

export default preguntasFrecuentes;